import styled from 'styled-components';
import { variants } from '../map';
export const H3Box = styled.h3.withConfig({
  displayName: "H3Box",
  componentId: "sc-mhts3r-0"
})(["margin:0;", ""], variants.h3);
H3Box.displayName = 'H3Box';